export const isoToTime = (isoString: string): string => {
  if (!isoString) return '';

  const date = new Date(isoString);

  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export const getAge = (birthday: string): number => {
  const birthDate = new Date(birthday);
  const today = new Date();
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age ? age : 0;
};

export const formatDateTime = (timestamp: string) => {
  const dateObj = new Date(timestamp);

  const date = dateObj.toISOString().split("T")[0];
  const time = dateObj.toISOString().split("T")[1].substring(0, 5);

  return `${date} ${time}`;
}

export const toAmPm = (time24: string) => {
  const [hourStr, minute] = time24.split(':');
  let hour = Number(hourStr);

  const period = hour >= 12 ? 'PM' : 'AM';

  hour = hour % 12;
  hour = hour === 0 ? 12 : hour;

  return `${hour}:${minute} ${period}`;
}